import { WithStyles, withStyles } from '@material-ui/core/styles'
import createStyles from '@material-ui/core/styles/createStyles'
import React from 'react'
import { useTranslation } from 'react-i18next'

import AnimatedLoader from 'src/components/AnimatedLoader'

const styles = () =>
  createStyles({
    root: {
      top: 0,
      left: 0,
      position: 'absolute',
      display: 'flex',
      width: '100%',
      height: '100%',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'rgba(0, 0, 0, 0.1)',
    },
    progressContainer: {
      display: 'flex',
      width: '100%',
      height: '100%',
      alignItems: 'center',
      justifyContent: 'center',
    },
  })

interface IMapSpinner extends WithStyles {
  loading: boolean
}

const MapSpinner = (props: IMapSpinner) => {
  const { classes, loading } = props
  const { t } = useTranslation()
  if (!loading) {
    return null
  }

  return (
    <div className={classes.root}>
      <div className={classes.progressContainer}>
        <AnimatedLoader loadingMessage={t('map.loadingMessage')} />
      </div>
    </div>
  )
}

export default withStyles(styles)(MapSpinner)
